<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">软件下载</div>
      </div>

      <img
        class="pwmat-trial-download-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-trial-download-container">
      <div class="pwmat-trial-download-content">
        <div class="pwmat-trial-download-content-title">
          <div class="pwmat-trial-download-content-title-text">
            PWmat试用版(docker镜像)
          </div>
          <div class="pwmat-trial-download-line"></div>
        </div>
        <div class="pwmat-trial-download-content-info">
          <p class="pwmat-trial-download-content-info-text">
            为了让更多的科研工作者体验和使用PWmat软件，PWmat现推出试用版本，其中包括GPU版本和CPU版本供大家试用。
            试用版本的PWmat是基于docker容器技术实现的，大家只需要在自己的服务器或者笔记本安装指定版本的docker就可以使用。docker镜像试用版本有很多限制，我们推荐<a
              href="//www.pwmat.com/pwmat-free-download"
              target="_blank"
              >安装试用版</a
            >本具体使用方法如下：
          </p>
        </div>

        <div>
          <table class="pwmat-trial-download-introduce-table">
            <tr class="pwmat-trial-download-introduce-th">
              <th class="pwmat-trial-download-introduce-text-th">docker镜像</th>
              <th class="pwmat-trial-download-introduce-text-th">安装</th>
              <th class="pwmat-trial-download-introduce-text-th">支持的系统</th>
              <th class="pwmat-trial-download-introduce-text-th">下载链接</th>
              <th class="pwmat-trial-download-introduce-text-th">更新时间</th>
            </tr>
            <tr
              class="pwmat-trial-download-introduce-td"
              v-for="version in PWmatTrialDownload"
            >
              <td class="pwmat-trial-download-introduce-text-td">
                {{ version.docker }}
              </td>
              <td class="pwmat-trial-download-introduce-text-td">
                <div v-html="version.install"></div>
              </td>
              <td class="pwmat-trial-download-introduce-text-td">
                {{ version.system }}
              </td>
              <td class="pwmat-trial-download-introduce-text-td">
                <a :href="version.downloadUrl">{{ version.download }}</a>
              </td>
              <td class="pwmat-trial-download-introduce-text-td">
                {{ version.updateTime }}
              </td>
            </tr>
          </table>
        </div>
        <div class="pwmat-trial-download-content-info">
          <p class="pwmat-trial-download-content-note-text">
            注：1.docker for Ubuntu安装官方链接：<a
              href="https://docs.docker.com/install/linux/docker-ce/ubuntu/"
              target="_blank"
              >https://docs.docker.com/install/linux/docker-ce/ubuntu/</a
            >
          </p>
          <p class="pwmat-trial-download-content-note-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.docker for
            windows安装官方链接：<a
              href="https://docs.docker.com/docker-for-windows/install/"
              target="_blank"
              >https://docs.docker.com/docker-for-windows/install/</a
            >
          </p>
          <p class="pwmat-trial-download-content-note-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.nvidia-docker安装官方链接：<a
              href="https://github.com/NVIDIA/nvidia-docker"
              target="_blank"
              >https://github.com/NVIDIA/nvidia-docker</a
            >
          </p>
          <p class="pwmat-trial-download-content-note-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.windows安装视频：<a
              :href="PWMAT_VIDEO + 'pwmat_cpu_docker.mp4'"
              target="_blank"
              >{{ PWMAT_VIDEO }}pwmat_cpu_docker.mp4</a
            >
          </p>
          <p class="pwmat-trial-download-content-note-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.linux安装视频：<a
              :href="PWMAT_VIDEO + 'pwmat_linux_docker.mp4'"
              target="_blank"
              >{{ PWMAT_VIDEO }}pwmat_linux_docker.mp4</a
            >
          </p>
        </div>

        <!--      <div class="pwmat-trial-download-video">
         <video width="100%" height="100%" controls="controls">
           <source :src='PWMAT_VIDEO+"pwmat_cpu_docker.mp4"' type="video/mp4">
           Your browser does not support the video tag.
         </video>
       </div>
       <p class="pwmat-trial-download-content-note-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.linux安装视频</p>
       <div class="pwmat-trial-download-video">
         <video width="100%" height="100%" controls="controls">
           <source :src='PWMAT_VIDEO+"pwmat_linux_docker.mp4"' type="video/mp4">
           Your browser does not support the video tag.
         </video>
       </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { PWmatTrialDownload } from "../../helpers/softwareDownload";
import { PWMAT_VIDEO } from "../../helpers/consts";

export default {
  name: "companyIntroduce",
  data() {
    return {
      PWmatTrialDownload,
      PWMAT_VIDEO,
    };
  },
  methods: {},
};
</script>

<style scoped>
.pwmat-trial-download-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-trial-download-background {
  margin-top: 70px;
}
.pwmat-trial-download-banner {
  overflow: hidden;
}
.pwmat-trial-download-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-trial-download-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-trial-download-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-trial-download-content-title {
  padding-top: 50px;
}
.pwmat-trial-download-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-trial-download-content-note-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-bottom: 0px;
}
.pwmat-trial-download-content-info {
  margin-top: 40px;
}
.pwmat-trial-download-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-trial-download-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}

.pwmat-trial-download-introduce-table {
  width: 100%;
  border: 1px solid rgba(240, 240, 240, 1);
}
.pwmat-trial-download-introduce-th {
  background: rgba(73, 145, 201, 1);
  height: 45px;
}
.pwmat-trial-download-introduce-td {
  height: 45px;
}
.pwmat-trial-download-introduce-td:hover {
  background: rgba(73, 145, 201, 0.1);
}
.pwmat-trial-download-introduce-text-th {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding-left: 16px;
}
.pwmat-trial-download-introduce-text-td {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 25px;
  padding: 16px;
}
.pwmat-trial-download-video {
  margin-top: 16px;
}
@media screen and (max-width: 482px) {
  .pwmat-trial-download-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-trial-download-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-trial-download-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-trial-download-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-trial-download-container {
    max-width: 1068px;
  }
}
</style>
